import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

// Styles for PDF
const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  header: {
    marginBottom: 20,
    textAlign: 'center',
  },
  title: {
    fontSize: 18,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 5,
  },
  subtitle: {
    fontSize: 14,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 3,
  },
  period: {
    fontSize: 11,
    color: '#666',
  },
  divider: {
    borderBottom: 1,
    borderColor: '#000',
    marginVertical: 10,
  },
  table: {
    marginTop: 10,
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#f0f0f0',
    padding: 8,
    fontFamily: 'Helvetica-Bold',
    borderBottom: 1,
    borderColor: '#000',
  },
  tableRow: {
    flexDirection: 'row',
    padding: 6,
    borderBottom: 0.5,
    borderColor: '#ddd',
  },
  tableRowReceita: {
    backgroundColor: '#f0fdf4',
  },
  tableRowDespesa: {
    backgroundColor: '#fff5f7',
  },
  col1: { width: '12%' },
  col2: { width: '8%' },
  col3: { width: '40%' },
  col4: { width: '25%' },
  col5: { width: '15%', textAlign: 'right' },
  textReceita: {
    color: '#00a859',
    fontFamily: 'Helvetica-Bold',
  },
  textDespesa: {
    color: '#f5576c',
    fontFamily: 'Helvetica-Bold',
  },
  textMuted: {
    color: '#666',
    fontSize: 8,
  },
  summary: {
    marginTop: 20,
    padding: 15,
    backgroundColor: '#f9f9f9',
    borderRadius: 5,
  },
  summaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
    fontSize: 11,
  },
  summaryDivider: {
    borderBottom: 1,
    borderColor: '#000',
    marginVertical: 8,
  },
  summaryTotal: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 8,
    fontSize: 12,
    fontFamily: 'Helvetica-Bold',
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 40,
    right: 40,
    textAlign: 'center',
    fontSize: 8,
    color: '#666',
  },
});

const BalancetePDF = ({ data }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR');
  };

  const monthNames = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <Text style={styles.title}>Palmeiras Country Clube</Text>
          <Text style={styles.subtitle}>Balancete Financeiro</Text>
          <Text style={styles.period}>
            {monthNames[data.mes - 1]} de {data.ano}
          </Text>
        </View>

        <View style={styles.divider} />

        {/* Table */}
        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={styles.col1}>Data</Text>
            <Text style={styles.col3}>Descrição</Text>
            <Text style={styles.col4}>Histórico</Text>
            <Text style={styles.col5}>Valor</Text>
          </View>

          {data.lancamentos.map((lanc, index) => (
            <View 
              key={`${lanc.tipo}-${lanc.id}-${index}`} 
              style={[
                styles.tableRow,
                lanc.tipo === 'receita' ? styles.tableRowReceita : styles.tableRowDespesa
              ]}
            >
              <Text style={styles.col1}>{formatDate(lanc.data)}</Text>
              <Text style={styles.col3}>{lanc.descricao}</Text>
              <Text style={[styles.col4, styles.textMuted]}>
                {lanc.historico || '-'}
              </Text>
              <Text style={[
                styles.col5,
                lanc.tipo === 'receita' ? styles.textReceita : styles.textDespesa
              ]}>
                {lanc.tipo === 'receita' ? '+' : '-'} {formatCurrency(lanc.valor)}
              </Text>
            </View>
          ))}
        </View>

        {/* Summary */}
        <View style={styles.summary}>
          <View style={styles.summaryRow}>
            <Text>Total de Receitas:</Text>
            <Text style={styles.textReceita}>{formatCurrency(data.totais.receitas)}</Text>
          </View>
          <View style={styles.summaryRow}>
            <Text>Total de Despesas:</Text>
            <Text style={styles.textDespesa}>{formatCurrency(data.totais.despesas)}</Text>
          </View>
          <View style={styles.summaryDivider} />
          <View style={styles.summaryTotal}>
            <Text>SALDO DO PERÍODO:</Text>
            <Text style={data.totais.saldo >= 0 ? styles.textReceita : styles.textDespesa}>
              {formatCurrency(data.totais.saldo)}
            </Text>
          </View>
        </View>

        {/* Footer */}
        <Text style={styles.footer}>
          Relatório gerado em {new Date().toLocaleString('pt-BR')}
        </Text>
      </Page>
    </Document>
  );
};

export default BalancetePDF;
